<script>
import httpClient from '@src/services/http.service'

import { mapGetters } from 'vuex'

import { SwiperSlide, Swiper } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import Translatable from '@src/mixins/translatable.js'
import Resizable from '@src/mixins/resizable.js'
import Likable from '@src/mixins/likable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'

import Layout from '@layouts/main.vue'

import Tabs from '@components/attraction-page/attraction-tips.vue'
import ReviewsSlider from '@components/common/sliders/reviews-slider.vue'
import StarsRating from '@components/stars-rating.vue'
import Slider from '@components/common/sliders/attractions-slider.vue'
import PageMap from '@components/page-map.vue'

import moment from "moment";

export default {
  page: {
    title: 'Attraction',
    meta: [{ name: 'description', content: 'Attraction Page' }],
  },
  components: {
    Layout,
    SwiperSlide,
    Swiper,
    Tabs,
    ReviewsSlider,
    Slider,
    StarsRating,
    PageMap
  },
  mixins: [
    Translatable,
    Likable,
    Resizable,
    SanitizerMixin
  ],
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      attraction: {},
      swiperOptions: {
        autoplay: {
          delay: 5000
        },
        speed: 1300,
        allowTouchMove: true,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        pagination: {
          el: '.header-pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
      },
      openingTimeLabelColor: 'closed',
      fullMap: false
    }
  },
  computed: {
    ...mapGetters('attractions', [
      'nearbyAttractions',
      'similarAttractions',
      'filteredAttractions',
      'freeEntryAttractions'
    ]),
    ...mapGetters('categories', [
      'getCategoryContent'
    ]),
    ...mapGetters('reviews', [
      'averageRating',
      'filteredReviews',
      'reviewsList'
    ]),
    ...mapGetters('currentNews', [
      'attractionNotice'
    ]),
    isFreeEntry() {
      return this.attraction.typology === 'pc_free_entry'
    },
    arrOf() {
      return  this.isFreeEntry ? this.freeEntryAttractions
      : this.filteredAttractions
    },
    benefitLAbel() {
      return  this.isFreeEntry ? `${this.getTranslatedContent('ATTRACTIONS_label_free_entry') }`:
        this.attraction.typology === 'pc_free' || !this.attraction.typology ?
        `${this.getTranslatedContent('ATTRACTIONS_label_included')} ${this.getTranslatedContent('ATTRACTIONS_label_with_pass')}` :
        `${this.attraction.benefit} ${this.getTranslatedContent('ATTRACTIONS_label_with_pass')}`
    },
    pageImg() {
      return this.desktopScreen ? this.attraction.webimages : this.attraction.images
    },
    attractionReviews() {
      return this.filteredReviews(this.attraction._id)
    },
    attractionRating() {
      return this.attractionReviews.reduce((first, second) => first + second.rating, 0) / this.attractionReviews.length || 0
    },
    actualNotice() {
      const notice = this.attractionNotice(this.attraction._id)
      return notice && moment().isBetween(notice.startDate, notice.endDate) ? notice : false
    },
    nearbyAttractionsExist() {
      return this.nearbyAttractions(this.attraction).length
    },
    similarAttractionsExist() {
      return this.similarAttractions(this.attraction).length
    },
    actualSchedule() {
      const schedules = this.attraction.opening || []
      return schedules.find(schedule => moment().isBetween(schedule.startDate, schedule.endDate))
    },
    openDay() {
      for (let i = 0; i < 8; i++) {
        let specialClosed
        let specialWork
        const day = this.actualSchedule.data[moment.weekdays(
          moment().add(i, 'days').day()
        ).toLowerCase()][0]

        this.actualSchedule.specialDates.forEach((date)=>{
          if(moment(date.date).format('YYYY-MM-DD')===moment().add(i, 'days').format('YYYY-MM-DD')){
            specialClosed = true
          }
        })
        this.actualSchedule.specialDates.forEach((date)=>{
          if(moment(date.date).format('YYYY-MM-DD')===moment().add(i, 'days').format('YYYY-MM-DD') && date.hours!=='closed'){
            specialWork = true
          }
        })

        const format = 'hh:mm'
        const time = day.split('-')
        const currentTime = moment()
        const specialDay = this.actualSchedule.specialDates.filter((specialDay)=>currentTime.isSame(moment(specialDay.date), 'day'))
        if ((day === 'closed' && !specialWork) || (day === 'Closed' && !specialWork) || !day || (specialClosed && !specialWork)||
        (currentTime.isAfter(moment(time[1], format))) && moment().isSame(moment().add(i,'days'),'day') && !specialWork) {
          continue;
        } else if(!!specialDay.length && specialWork && moment().isSame(moment(specialDay[0].date), 'day')
        && currentTime.isAfter(moment(specialDay[0].hours.split('-')[1], format))) {
          continue
        }else {
          return moment().add(i, 'days')
        }
      }
      return ''
    },
    openingTimeLabel() {
      const weekday = moment.weekdays(
        moment().day()
      ).toLowerCase()

      const season = this.attraction.opening.filter(season => season.isAvailable || season.isFuture)

      if(season.length){
        if(!season[0].isFuture){
          if (this.actualSchedule) {
            if (this.actualSchedule.type === 'times') {
              const workingTime = this.actualSchedule.data[weekday]
              const today = workingTime.filter((el, i) => this.isOpenedTimes(el))[0]
              let isSpecial
              this.actualSchedule.specialDates.forEach((date)=>{
              if(moment(date.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')){
                isSpecial =  true
              }})
              if (today && !isSpecial) {
                this.setOpeningTimeLabelColor('open')
                return `${today} ${this.getTranslatedContent('TODAY')}`
              } else {
                if (this.openDay) {
                  const tomorrowWeekDay = moment.weekdays(this.openDay.day()).toLowerCase()
                  const workingTime = this.actualSchedule.data[tomorrowWeekDay][0]
                  const untilClosedDay = this.openDay.calendar().split(" at")[0].toUpperCase()
                  this.setOpeningTimeLabelColor('open')
                  return `${workingTime.split('-')[0]} ${this.getTranslatedContent(`${untilClosedDay}`)}`
                }
                return `${this.getTranslatedContent('CLOSED_NOW')}`
              }
            } else {
              // const workingTime = this.actualSchedule.data[weekday][0]
              const specialDay = this.actualSchedule.specialDates.filter((specialDay)=>moment().isSame(moment(specialDay.date), 'day'))
                  let workingTime
                  if(specialDay.length > 0){
                    workingTime = specialDay[0].hours
                  }else{
                    workingTime = this.actualSchedule.data[weekday][0]
                  }

              // let special = false
              //   for (let i = 1; i < 8; i++) {
              //   this.actualSchedule.specialDates.forEach((date)=>{
              //     if(moment(date.date).format('YYYY-MM-DD')===moment().add(i, 'days').format('YYYY-MM-DD')){
              //       console.log(moment(date.date).format('YYYY-MM-DD'),"moment(date.date).format('YYYY-MM-DD')")
              //       console.log(moment().add(i, 'days').format('YYYY-MM-DD'),"moment().add(i, 'days').format('YYYY-MM-DD')")

              //       special = true
              //     }
              //   })
              // }
              if (this.isOpened(workingTime)) {
                let special = false

                  this.actualSchedule.specialDates.forEach((date)=>{

                    if(moment(date.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && date.hours === 'closed'){
                      special = true

                    }
                  })
                if(!special){
                  this.setOpeningTimeLabelColor('open')
                  return `${this.getTranslatedContent('OPEN_UNTIL_TODAY').replace( "$time", workingTime.split('-')[1])}`
                }else{
                  if (this.openDay) {
                  const specialDay = this.actualSchedule.specialDates.filter((specialDay)=>this.openDay.isSame(moment(specialDay.date), 'day') )
                  console.log(specialDay,'specialDay')
                  const tomorrowWeekDay = moment.weekdays(this.openDay.day()).toLowerCase()
                  let workingTime
                  if(specialDay.length > 0 && moment().isBefore(moment(specialDay[0].hours.split('-')[1], 'hh:mm'))){
                    workingTime = specialDay[0].hours
                  }else{
                    workingTime = this.actualSchedule.data[tomorrowWeekDay][0]

                  }
                  const untilClosedDay = this.openDay.calendar().split(" at")[0].toUpperCase()
                  const closedTime = `${workingTime.split('-')[0]} ${this.getTranslatedContent(`${untilClosedDay}`) ? this.getTranslatedContent(`${untilClosedDay}`) : moment(untilClosedDay).locale(this.currentLanguage || 'en').format('MMM, DD YYYY') }`

                  // return `${this.getTranslatedContent('CLOSED_UNTIL').replace("$time", closedTime)}`
                  return `${this.getTranslatedContent('CLOSED_NOW')} ${this.getTranslatedContent('OPENS_AT').replace("{{time}}", closedTime)}`
                }
                return `${this.getTranslatedContent('CLOSED_NOW')}`
                }

              } else {
                if (this.openDay) {
                  const specialDay = this.actualSchedule.specialDates.filter((specialDay)=>this.openDay.isSame(moment(specialDay.date), 'day'))
                  console.log(specialDay,'specialDay')

                  const tomorrowWeekDay =  moment.weekdays(this.openDay.day()).toLowerCase()
                  let workingTime
                  if(specialDay.length > 0 && (moment().isBefore(moment(specialDay[0].hours.split('-')[1], 'hh:mm'))||!this.openDay.isSame(moment(),'day') )){
                    workingTime = specialDay[0].hours
                  }else{
                    workingTime = this.actualSchedule.data[tomorrowWeekDay][0]
                  }
                  const untilClosedDay = this.openDay.calendar().split(" at")[0].toUpperCase()
                  const closedTime = `${workingTime.split('-')[0]} ${this.getTranslatedContent(`${untilClosedDay}`) ? this.getTranslatedContent(`${untilClosedDay}`) : moment(untilClosedDay).locale(this.currentLanguage || 'en').format('MMM, DD YYYY') }`
                  // return `${this.getTranslatedContent('CLOSED_UNTIL').replace("$time", closedTime)}`
                  return `${this.getTranslatedContent('CLOSED_NOW')} ${this.getTranslatedContent('OPENS_AT').replace("{{time}}", closedTime)}`
                }
                return `${this.getTranslatedContent('CLOSED_NOW')}`
              }
            }
          }else{
            return ''
          }
        }else{
          this.setOpeningTimeLabelColor('open')
          return `${this.getTranslatedContent('OPENS_ON').replace("{{date}}", moment(season[0].startDate).format('MMM, DD YYYY'))}`
        }
      }
      this.setOpeningTimeLabelColor('broke')
      return `${this.getTranslatedContent('NOT_SPECIFIED')}`
    },
    timeColor() {
      return this.openingTimeLabelColor.includes('closed') ? 'red' : this.openingTimeLabelColor.includes('broke') ? 'black' : 'green'
    },
    nextAttraction() {
      const attr = this.arrOf.find(obj => obj._id === this.attraction._id)
      const attractionOrderNum = this.arrOf.indexOf(attr)
      if (this.attraction._id !== this.arrOf[this.arrOf.length - 1]._id) {
        return this.arrOf[attractionOrderNum + 1].slug
      }
      else {
        return ''
      }
    },
    previousAttraction() {
      const attr = this.arrOf.find(obj => obj._id === this.attraction._id)
      const attractionOrderNum = this.arrOf.indexOf(attr)
      if (attractionOrderNum > 0) {
        return this.arrOf[attractionOrderNum - 1].slug
      } else {
        return ''
      }
    },
    currentMap() {
      return this.fullMap ? document.querySelector('#map-wrapper-full')
      : document.querySelector('.secondary-column')
    }
  },
  async created() {
    // this.$store.dispatch('attractions/fetchAttractions')
    await this.$store.dispatch('categories/fetchCategories')
    const response = await httpClient.get(`objectNew/slug/${this.slug}`)
    this.attraction = response.data
  },
  methods: {
    getBackground(image) {
      return {
        backgroundImage: `url("${process.env.VUE_APP_STATIC_URL}${image}")`,
        backgroundSize: 'cover'
      }
    },
    isOpened(workingTimeString) {
      const format = 'hh:mm'
      const time = workingTimeString.split('-')
      const currentTime = moment()
      return currentTime.isBetween(moment(time[0], format), moment(time[1], format))
    },
    isOpenedTimes(workingTimeString) {
      const format = 'hh:mm'
      const currentTime = moment()
      return currentTime.isSameOrBefore(moment(workingTimeString, format))
    },
    setOpeningTimeLabelColor(color) {
      this.openingTimeLabelColor = color
    },
    openMap() {
      this.fullMap = !this.fullMap
      this.scrollToElement({behavior: 'smooth'})
    },
    scrollToElement(options) {
      if (this.currentMap) {
        this.currentMap.scrollIntoView(options);
      }
    },
  }
}
</script>

<template>
  <Layout>
    <section class="header-slider">
      <Swiper v-if="pageImg && pageImg.length > 1" :options="swiperOptions">
        <SwiperSlide v-for="(image, index) in pageImg" :key="index">
          <div class="slide" :style="getBackground(image)"></div>
        </SwiperSlide>
        <div slot="pagination" class="header-pagination"></div>
      </Swiper>
      <div v-else class="slide" :style="getBackground(pageImg && pageImg[0])"></div>
    </section>
    <section class="justify-center">
      <div class="container header-content " style="height: 135px">
        <div class="title-block">
          <h1 class="header-title">{{ getTranslatedContent('title', attraction.content) }}</h1>
          <h3 class="header-subtitle" v-html="getTranslatedContent('subtitle', attraction.content)"></h3>
        </div>
      </div>
    </section>
    <main class="justify-center">
      <div class="container content">
        <div class="main-column">
          <div class="attraction-banner">
            <div id="first-col" class="column">
              <div class="benefit-container">
                <div class="benefit-label" :class="isFreeEntry && 'green'">
                  <p class="benefit-label-text">{{ benefitLAbel }}</p>
                </div>
                <div :class="isLiked(attraction._id) ? 'like-btn-active' : 'like-btn-inactive'" @click="like(attraction._id)"></div>
              </div>
              <div v-if="desktopScreen" class="open-time" :class="timeColor">
                <p>{{ openingTimeLabel }}</p>
              </div>
            </div>
            <div id="second-col" class="column">
              <router-link :to="{ name: 'attractions' }" class="link">
                <button class="button">{{ getTranslatedContent('ATTRACTIONS_all_attractions_title') }}</button>
              </router-link>
              <div v-for="category in attraction.categories" :key="category" class="attraction-category">
                <router-link :to="{ name: 'attractions', query: { category: category } }" class="link">
                  <p class="category-title">
                    {{ getTranslatedContent('title', getCategoryContent(category)) }}
                  </p>
                </router-link>
              </div>
            </div>
            <div id="third-col" class="column">
              <p v-html="bannerText(attraction.content)"></p>
            </div>
            <div v-if="actualNotice" id="forth-col">
              <div class="notice-icon"></div>
              <div>
                <p class="title">{{ getTranslatedContent('title', actualNotice.content) }}</p>
                <p class="text" v-html="getTranslatedContent('text', actualNotice.content)"></p>
              </div>
            </div>
            <div v-if="!desktopScreen" id="fiv-col">
              <p class="open-time" :class="timeColor">{{ openingTimeLabel }}</p>
            </div>
          </div>
        </div>
        <div class="secondary-column">
          <Tabs :attraction="attraction"/>
          <div class="order-button">
            <router-link :to="{ name: 'eshop' }">{{ getTranslatedContent('CALCULATOR_order_your_coolpass') }}</router-link>
          </div>
          <div class="map-wrapper" :class="fullMap && 'disabled'">
            <PageMap
              :attractions="[attraction]"
              :full-map="fullMap"
              @open-map="openMap"
            />
          </div>
        </div>
        <div v-if="desktopScreen" class="attraction-description">
          <div class="attraction-text-section" v-html="description(attraction.content)">
          </div>
          <div id="map-wrapper-full"></div>
        </div>
      </div>
    </main>
    <section class="justify-center">
      <div v-if="fullMap" class="container map-wrapper-full">
        <PageMap
          :attractions="[attraction]"
          :full-map="fullMap"
          @open-map="openMap"
        />
      </div>
    </section>
    <section class="justify-center">
      <div class="container navigation">
        <router-link
          :to="{
            name: 'attraction',
            params: {
              slug: previousAttraction,
            },
          }"
          class="attraction-nav-btn"
          :class="previousAttraction || 'disabled'"
        >
          <div class="previous-attraction">
            <i></i>
            <p v-html="getTranslatedContent('ATTRACTION_previous_attraction')"></p>
          </div>
        </router-link>
        <router-link
          :to="{
            name: 'attraction',
            params: {
              slug: nextAttraction,
            },
          }"
          class="attraction-nav-btn next-attraction"
          :class="nextAttraction || 'disabled'"
        >
          <div class="next-attraction">
            <p v-html="getTranslatedContent('ATTRACTION_next_attraction')"></p>
            <i></i>
          </div>
        </router-link>
      </div>
    </section>
    <section>
      <div v-if="!desktopScreen" class="attraction-description">
        <div class="attraction-text-section" v-html="description(attraction.content)"></div>
      </div>
    </section>
    <section class="reviews-title justify-center">
      <div class="container">
        <div class="reviews-section-header">
          <h3 class="reviews-title">
            {{ getTranslatedContent('ATTRACTION_reviews') }}
          </h3>
          <div class="rating-wrapper">
            <div v-if="attractionRating" class="average-review-rating">
              <p class="average-rating">
                {{ attractionRating.toFixed(1) }}
              </p>
            </div>
            <StarsRating :rating="attractionRating.toFixed(0)"/>
          </div>
        </div>
      </div>
    </section>
    <section class="reviews">
      <ReviewsSlider :reviews="attractionReviews" :attraction="attraction"/>
    </section>
    <section v-if="nearbyAttractionsExist" class="nearby-attractions">
      <h3 class="container">{{ getTranslatedContent('ATTRACTION_nearby_attractions') }}</h3>
      <Slider :id="'nearby'" :attractions="nearbyAttractions(attraction)" :isnt-paginated="true"/>
    </section>
    <section v-if="similarAttractionsExist" class="similar-attractions">
      <h3 class="container">{{ getTranslatedContent('ATTRACTION_similar_attractions') }}</h3>
      <Slider :id="'similar'" :attractions="similarAttractions(attraction)" :isnt-paginated="true"/>
    </section>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.header-slider {
  min-height: 550px;
}

.content {
  position: relative;
  display: grid;
  grid-template-columns: 751px 367px;
  column-gap: 21px;
  margin-top: -99px;
  z-index: 1;
}

.main-column {
  grid-row: 1 / 1;
}

.attraction-banner {
  width: 751px;
  min-height: 160px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0 8px 12px rgba(76, 72, 124, 0.08);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  user-select: none;

  & .column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: auto;
  }

  #first-col {
    margin-top: 20px;

    .benefit-container {
      display: flex;
      align-items: center;
    }

    .benefit-label {
      width: 235px;
      height: 45px;

      background: $yellow;
      border-radius: 0 5px 5px 0;

      display: flex;
      justify-content: center;
      align-items: center;

      &.green {
        background: $green;
      }

      .benefit-label-text {
        font-family: Open Sans Semibold, sans-serif;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: $dark-blue;
      }
    }

    & .like-mixin {
      margin-left: 28px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    & .like-btn-inactive {
      @extend .like-mixin;
      background: url("../../../assets/icons/heart-icon-dark.svg") center no-repeat;

      &:hover {
        background: url("../../../assets/icons/heart-icon-dark-active.svg") center no-repeat;
        opacity: 0.8;
      }
    }

    & .like-btn-active {
      @extend .like-mixin;
      background: url("../../../assets/icons/heart-icon-dark-active.svg") center no-repeat;

      &:hover {
        opacity: 0.8;
      }
    }

    & .open-time {
      margin-left: auto;
      margin-right: 20px;

      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
      color: $dark-blue;

      &.green {
        color: $green;
      }

      &.red {
        color: $orange;
      }

      &.black {
        color: #252c3e;
      }
    }
  }

  #second-col {
    margin-left: 20px;
    margin-top: 20px;
    order: 1;

    .attraction-category {
      width: auto;
      height: 32px;
      border: 1px solid $dark-blue;
      box-sizing: border-box;
      border-radius: 5px;

      padding-right: 10px;
      padding-left: 10px;

      margin-right: 10px;
      margin-bottom: 5px;

      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .category-title {
        font-family: "Open Sans Semibold", sans-serif;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        text-transform: uppercase;
        color: $dark-blue;
      }

      &:hover {
        border: 1px solid $dark-gray;
      }
    }
  }

  #third-col {
    margin: 20px;

    order: 2;

    ::v-deep a {
      color: $gray;
      text-decoration: none;

      &:hover {
        color: $orange;
      }
    }

    ::v-deep p {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 21px;
      color: $dark-blue;
      user-select: none;

      & em {
        font-style: italic;
      }

      & strong {
        font-family: Open Sans Bold, sans-serif;
        font-style: normal;
        font-weight: bold;
      }

      & .ql-align-center {
        text-align: center;
      }
    }
  }

  #forth-col {
    display: flex;
    flex-direction: row;
    padding: 12px 20px 12px 5px;
    background: $orange;

    order: 3;

    ::v-deep a {
      &:hover {
        text-decoration: underline;
      }
    }

    p {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: $white;
    }

    .title {
      font-family: Open Sans Bold, sans-serif;
      font-weight: bold;
      font-size: 16px;
      line-height: 21px;
      margin-bottom: 5px;
    }

    .notice-icon {
      width: 24px;
      height: 24px;
      background: url("../../../assets/icons/notice.svg") center no-repeat;
      padding-left: 35px;
    }
  }
  #fiv-col {
    & .open-time {
      margin: 10px 8px 3px 8px;
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
      color: $dark-blue;

      &.green {
        color: $green;
      }

      &.red {
        color: $orange;
      }


    }
  }
}

.link {
  text-decoration: none;
  .button {
    min-width: 100px;
    padding: 8px 10px;
    height: 32px;
    border: 1px solid $dark-blue;
    background: $white;
    border-radius: 5px;
    color: $dark-blue;
    font-family: Open Sans Semibold, sans-serif;
    font-style: normal;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 16px;
    margin: 0 10px 5px 0;

    &:hover {
      border: 1px solid $dark-gray;
    }
  }
}

.attraction-description {
  user-select: none;

  .description-subtitle {
    margin-top: 25px;
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    text-transform: uppercase;
    color: $dark-blue;
  }

  ::v-deep .attraction-text-section {
    margin-top: 19px;
    font-family: 'Open Sans', sans-serif;

    font-weight: normal;
    font-size: 14px;
    line-height: 23px;
    color: $black;
    // opacity: 0.8;

    & ul {
      margin-left: 20px;
      list-style: initial;
    }

    & strong {
      font-family: Open Sans Bold, sans-serif;
      font-style: normal;
      font-weight: bold;
    }

    & em {
      font-style: italic;
    }

    & a {
      color: $gray;
      text-decoration: none;

      &:hover {
        color: $orange;
      }
    }

    & .ql-align-center {
      text-align: center;
    }
  }
}

.secondary-column {
  grid-row: 1 / 4;

  .order-button {
    width: 367px;
    height: 63px;
    background: $dark-blue;
    border-radius: 0px 0px 10px 10px;

    margin-top: 5px;

    &:hover {
      background: #2F384F;
    }

    & a {
      display: block;
      width: 100%;
      height: 100%;
      line-height: 23px;
      text-align: center;

      text-decoration: none;

      font-family: Open Sans Bold, sans-serif;
      font-weight: bold;
      font-size: 18px;
      text-transform: uppercase;
      color: #FFFFFF;

      padding-top: 20px;
      padding-bottom: 20px;
    }
  }

}

.slide {
  height: 550px;
  background-repeat: no-repeat;
  background-position: center;
}

.map-wrapper, .map-wrapper-full {
  height: 292px;
  margin-top: 30px;

  &.disabled {
    display: none;
  }
}

.map-wrapper-full {
  height: 600px;
}

::v-deep .swiper-wrapper,
.swiper-container {
  // we need the slider not to overlap the toggled dropdown menu
  z-index: auto;
}

.header-content {
  position: absolute;
  top: 217px;
}

.title-block {
  width: 840px;
  min-height: 135px;
  height: auto;
  background: rgba(37, 44, 62, 0.36);
  padding: 9px 35px 10px 22px;
  box-sizing: border-box;
}

.header-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 48px;
  line-height: 62px;
  text-transform: uppercase;
  color: $white;
}
.header-subtitle {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 29px;
  color: $white;
}


::v-deep .header-pagination {
  @extend .pagination;
  position: absolute;
  bottom: 109px;

  & .bullet {
    background: #FFFFFF;
    opacity: 0.8;
  }

  & .bullet-active {
    background: $orange;
    opacity: 1;
  }
}

.bullet {
  background: #FFFFFF;
  opacity: 0.8;
}

.navigation {
  margin-top: 40px;
  display: flex;
  flex-direction: row;

  & .previous-attraction,
  & .next-attraction {
    display: flex;
    flex-direction: row;
    align-items: center;

    cursor: pointer;

    p {
      max-width: 72px;
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      color: $dark-blue;
    }

    i {
      display: block;
      width: 24px;
      height: 24px;
    }
  }

  & .previous-attraction {
    p {
      margin-left: 15px;
      text-align: left;
    }

    i {
      background: url("../../../assets/icons/left-arrow-orange.svg") no-repeat center;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  & .next-attraction {
    margin-left: auto;

    p {
      margin-right: 15px;
      text-align: right;
    }

    i {
      background: url("../../../assets/icons/right-arrow-orange.svg") no-repeat center;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  .attraction-nav-btn {
    display: block;
    text-decoration: none;
    user-select: none;
  }
}

.disabled {
  pointer-events: none;
  opacity: 0.2;
}

.reviews-section-header {
  margin-top: 79px;
  display: flex;
  flex-direction: row;
  align-items: center;

  & .reviews-title {
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 22px;
    line-height: 29px;
    text-transform: uppercase;
    color: $dark-blue;
  }

  & .rating-wrapper {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;

    .average-review-rating {
      margin-right: 12px;

      .average-rating {
        font-family: Open Sans Bold, sans-serif;
        font-weight: 600;
        font-size: 22px;
        line-height: 29px;
        color: $dark-blue;
      }
    }
  }
}

.reviews {
  margin-top: 30px;
}

.similar-attractions,
.nearby-attractions {
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    margin-top: 40px;
    margin-bottom: 30px;

    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 22px;
    line-height: 29px;
    text-transform: uppercase;
    color: $dark-blue;
  }
}

::v-deep #see-all {
  display: none;
}

@media only screen and (max-width: $screen-width-xs) {
  .header-slider, .slide {
    min-height: 274px;
    height: 244px;
  }

  .header-content {
    top: 70px;
  }

  .header-pagination {
    bottom: 30px;
  }

  .content {
    width: 100%;
    grid-template-columns: 100%;
    margin-top: -25px;
  }

  .secondary-column {
    grid-row: auto;
    .tabs, .order-button {
    width: 100%;
    }
  }

  main, .header-content {
    .container {
      padding: 0;
    }
  }

  .map-wrapper {
    width: 100%;
  }

  .main-column {
    .attraction-banner {
      width: 100%;
      padding: 0 0 20px;
      border-radius: 20px 20px 0 0;

      #first-col {
        margin: 0;
        flex-direction: column;
        align-items: flex-start;

        .benefit-container {
          width: 100%;
        }

        .open-time {
          margin: 10px 8px 3px 8px;
        }

        .benefit-label {
          border-radius: 20px 5px 5px 0px;
        }

        & .like-mixin {
          margin-left: auto;
          margin-right: 27px;
        }

        & .like-btn-inactive {
          &:hover {
            background: url("../../../assets/icons/heart-icon-dark.svg") center no-repeat;
            opacity: 1;
          }
        }
      }

      #second-col {
        margin: 8px;

        order: 3;

      }

      #third-col {
        margin: 0 8px;

        order: 4;

        p {
          font-size: 14px;
          line-height: 23px;
        }
      }

      #forth-col {
        padding: 12px 10px 12px 0px;
        background: $orange;

        order: 1;

        p {
          font-size: 12px;
          line-height: 16px;
        }

        .title {
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 5px;
        }

        .notice-icon {
          padding-left: 35px;
        }
      }

      #fiv-col {
        order: 2;
      }
    }
  }

  .title-block {
    width: 100%;
    min-height: 125px;
    height: auto;
    padding: 8px 13px;

    .header-title {
      font-size: 26px;
      line-height: 34px;
      // margin: 10px 8px 10px 0;
      margin: 10px 0 10px 0;
    }

    .header-subtitle {
      font-size: 16px;
      line-height: 21px;
      margin: 0;
    }
  }

  .attraction-description {
    margin-top: 0px;
    padding: 0 8px;
  }

  .reviews-section-header {
      margin-top: 40px;
      flex-direction: column;
      align-items: flex-start;

    & .reviews-title {
      font-size: 18px;
      line-height: 23px;
    }

    & .rating-wrapper {
      margin-left: 10px;
      margin-top: 20px;
      flex-direction: row-reverse;

      .average-review-rating {
        margin-left: 12px;
      }
    }
  }

  .reviews {
    margin-top: 18px;
  }

  .navigation {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .similar-attractions,
  .nearby-attractions {
    h3 {
      font-size: 18px;
      line-height: 23px;
      margin-bottom: 15px;
    }
  }

  ::v-deep .review-button {
    width: 100%;
  }

  .container.header-content {
    padding: 0;
  }
}
</style>
